import { Box, Typography, useTheme } from "@mui/material";

/** Gradient "New" pill shown next to a freshly shipped profile-menu option. */
export const NewFeaturePill = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        px: "8px",
        py: "2px",
        borderRadius: "4px",
        background: `linear-gradient(90deg, ${theme.palette.primitive.system.violet[600]}, ${theme.palette.primitive.system.magenta[600]})`,
      }}
    >
      <Typography
        variant="body-small"
        sx={{ color: theme.palette.neutral.main, fontWeight: 600 }}
      >
        New
      </Typography>
    </Box>
  );
};
